import { createAction, props } from '@ngrx/store';

import { DeliveryLine } from '../../../delivery/models/delivery.model';
import {
  Flock,
  FlockVariant,
  FlockWeekChartFilters,
  HenHatchery,
  PorphyrioCategories,
  FarmResource,
  RearingOrganization,
  WeekRegistrationFilters,
  WeekRegistrationKPIItem,
  FarmResourcesDivision,
  CarbonFootprintResponse,
  WeekRegistration,
} from '../../models/flock.model';
import { FlockWeekDataSet } from '../../models/flock.model';

export const loadData = createAction('[Flock] Load data', props<{ variant: FlockVariant }>());
export const clearFlockState = createAction('[Flock] Clear flock state');
export const setFlockVariant = createAction(
  '[Flock] Set flock variant',
  props<{ variant: FlockVariant }>(),
);
export const loadFlocksRequest = createAction(
  '[Flock] Load Flocks request',
  props<{ variant: FlockVariant }>(),
);
export const loadFlocksSuccess = createAction(
  '[Flock] Load Flocks success',
  props<{ flocks: Flock[] }>(),
);
export const loadFlocksError = createAction('[Flock] Load Flocks Error', props<{ error: Error }>());

export const loadFlocksForAllLocationsRequest = createAction(
  '[Flock] Load Flocks for all locations request',
);
export const loadFlocksForAllLocationsSuccess = createAction(
  '[Flock] Load Flocks for all locations success',
  props<{ flocksForAllLocations: Flock[] }>(),
);
export const loadFlocksForAllLocationsError = createAction(
  '[Flock] Load Flocks for all locations Error',
  props<{ error: Error }>(),
);

export const loadSelectedFlockId = createAction('[Flock] Load Selected Flock Id');

export const setSelectedFlockId = createAction(
  '[Flock] Set Selected Flock Id',
  props<{ id: number; save: boolean; reloadWeekData: boolean }>(),
);

export const upsertFlockRequest = createAction(
  '[Flock] Upsert Flock request',
  props<{ request: Flock; variant?: FlockVariant }>(),
);
export const upsertFlockSuccess = createAction(
  '[Flock] Upsert Flock success',
  props<{ flock: Flock }>(),
);
export const upsertFlockError = createAction(
  '[Flock] Upsert Flocks Error',
  props<{ error: Error }>(),
);

export const deleteFlockWithConfirmation = createAction(
  '[Flock] Delete Flock with confirmation',
  props<{ id: number }>(),
);
export const deleteFlockRequest = createAction(
  '[Flock] Delete Flock request',
  props<{ id: number }>(),
);

export const deleteFlockSuccess = createAction(
  '[Flock] Delete Flock success',
  props<{ id: number }>(),
);
export const deleteFlockError = createAction(
  '[Flock] Delete Flock Error',
  props<{ error: Error }>(),
);

export const deleteFlockWeekRegistrationWithConfirmation = createAction(
  '[Flock] Delete FlockWeekRegistration with confirmation',
  props<{ flockId: number; weekNumber: number }>(),
);
export const deleteFlockWeekRegistrationRequest = createAction(
  '[Flock] Delete FlockWeekRegistration request',
  props<{ flockId: number; weekNumber: number }>(),
);

export const deleteFlockWeekRegistrationSuccess = createAction(
  '[Flock] Delete FlockWeekRegistration success',
  props<{ id: number }>(),
);
export const deleteFlockWeekRegistrationError = createAction(
  '[Flock] Delete FlockWeekRegistration Error',
  props<{ error: Error }>(),
);

export const upsertBreederWeekRegistrationRequest = createAction(
  '[Flock] Upsert Breeder WeekRegistration request',
  props<{ flockId: number; weekRegistration: WeekRegistration }>(),
);
export const upsertBreederWeekRegistrationSuccess = createAction(
  '[Flock] Upsert Breeder WeekRegistration success',
  props<{ flockId: number; weekRegistration: WeekRegistration }>(),
);
export const upsertBreederWeekRegistrationError = createAction(
  '[Flock] Upsert Breeder WeekRegistration Error',
  props<{ error: Error }>(),
);

export const loadHatcheriesRequest = createAction('[Flock] Load hatcheries request');
export const loadHatcheriesSuccess = createAction(
  '[Flock] Load hatcheries success',
  props<{ hatcheries: HenHatchery[] }>(),
);
export const loadHatcheriesError = createAction(
  '[Flock] Load hatcheries Error',
  props<{ error: Error }>(),
);
export const loadRearingOrganizationsRequest = createAction(
  '[Flock] Load rearing organizations request',
);
export const loadRearingOrganizationsSuccess = createAction(
  '[Flock] Load rearing organizations success',
  props<{ rearingOrganizations: RearingOrganization[] }>(),
);
export const loadRearingOrganizationsError = createAction(
  '[Flock] Load rearing organizations Error',
  props<{ error: Error }>(),
);

export const loadDeliveryLinesRequest = createAction('[Flock] Load DeliveryLines Request');
export const loadDeliveryLinesSuccess = createAction(
  '[Flock] Load DeliveryLines Success',
  props<{ deliveryLines: DeliveryLine[] }>(),
);
export const loadDeliveryLinesError = createAction(
  '[Flock] Load DeliveryLines Error',
  props<{ error: Error }>(),
);

export const loadFlockWeekChartFilters = createAction('[Flock] Load flock week chart filters');

export const loadFlockBenchmarks = createAction(
  '[Flock] Load flock benchmarks',
  props<{ flock: Flock; kpi: WeekRegistrationKPIItem }>(),
);
export const loadBreederFlockChart = createAction(
  '[Breeder flock] Load chart',
  props<{ flock: Flock; kpi: WeekRegistrationKPIItem }>(),
);
export const loadFlockBenchmarksError = createAction(
  '[Flock] Load flock benchmarks Error',
  props<{ error: Error }>(),
);

export const loadFlockWeekDataOfFlockRequest = createAction(
  '[Flock] Load flock week data of flock request',
  props<{ flockId: number }>(),
);
export const loadFlockWeekDataOfFlockSuccess = createAction(
  '[Flock] Load flock week data of flock Success',
  props<{ data: FlockWeekDataSet }>(),
);

export const loadPorphyrioCategoriesRequest = createAction(
  '[Flock] Load Porphyrio categories request',
);
export const loadPorphyrioCategoriesSuccess = createAction(
  '[Flock] Load Porphyrio categories success',
  props<{ porphyrioCategories: PorphyrioCategories }>(),
);

export const upsertFlockWeekChartFiltersRequest = createAction(
  '[Flock] Upsert flock week chart filters request',
  props<{ flockWeekChartFilters: FlockWeekChartFilters }>(),
);
export const upsertFlockWeekChartFiltersSuccess = createAction(
  '[Flock] Upsert flock week chart filters success',
  props<{ flockWeekChartFilters: FlockWeekChartFilters }>(),
);

export const loadFlockWeekDataOfOtherFlockRequest = createAction(
  '[Flock] Load flock week data of other flock request',
  props<{ otherFlockId: number }>(),
);
export const loadFlockWeekDataOfOtherFlockSuccess = createAction(
  '[Flock] Load flock week data of other flock Success',
  props<{ data: FlockWeekDataSet }>(),
);

export const clearFlockWeekDataOfOtherFlock = createAction(
  '[Flock] Clear flock week data of other flock',
);

export const loadWeekRegistrationsRequest = createAction(
  '[Flock] Load week registration filters request',
);

export const upsertWeekRegistrationFiltersRequest = createAction(
  '[Flock] Upsert week registration filters request',
  props<{ weekRegistrationFilters: WeekRegistrationFilters }>(),
);

export const upsertWeekRegistrationFiltersSuccess = createAction(
  '[Flock] Upsert week registration filters success',
  props<{ weekRegistrationFilters: WeekRegistrationFilters }>(),
);

export const resetWeekRegistrationFiltersRequest = createAction(
  '[Flock] Reset week registration filters request',
);

export const loadIsDetailedViewSelectedRequest = createAction(
  '[Flock] Load week registration filters request',
);

export const setIsDetailedViewSelectedRequest = createAction(
  '[Flock] Set is detailed view selected request',
  props<{ isDetailedViewSelected: boolean }>(),
);

export const setIsDetailedViewSelectedSuccess = createAction(
  '[Flock] Set is detailed view selected success',
  props<{ isDetailedViewSelected: boolean }>(),
);

export const loadFarmResourcesRequest = createAction('[Flock] Load Farm-Resources request');

export const loadFarmResourcesSuccess = createAction(
  '[Flock] Load Farm-Resources success',
  props<{ farmResources: FarmResource[]; flockResources: FarmResourcesDivision[] }>(),
);
export const loadFarmResourcesError = createAction(
  '[Flock] Load Farm-Resources Error',
  props<{ error: Error }>(),
);

export const upsertFarmResourceRequest = createAction(
  '[Flock] Upsert Farm-Resource request',
  props<{ request: FarmResource }>(),
);

export const upsertFarmResourceSuccess = createAction(
  '[Flock] Upsert Farm-Resource success',
  props<{ farmResource: FarmResource }>(),
);

export const upsertFarmResourceError = createAction(
  '[Flock] Upsert Farm-Resource Error',
  props<{ error: Error }>(),
);

export const deleteFarmResourceWithConfirmationRequest = createAction(
  '[Flock] Delete Farm-Resource request with confirmation',
  props<{ id: number }>(),
);

export const deleteFarmResourceRequest = createAction(
  '[Flock] Delete Farm-Resource request',
  props<{ id: number }>(),
);

export const deleteFarmResourceSuccess = createAction(
  '[Flock] Delete Farm-Resource success',
  props<{ id: number }>(),
);

export const deleteFarmResourceError = createAction(
  '[Flock] Delete Farm-Resource Error',
  props<{ error: Error }>(),
);

export const loadCarbonFootprintRequest = createAction(
  '[Flock] Load carbon footprint request',
  props<{ flockId: number }>(),
);
export const loadCarbonFootprintSuccess = createAction(
  '[Flock] Load carbon footprint Success',
  props<{ data: CarbonFootprintResponse }>(),
);
export const loadCarbonFootprintError = createAction(
  '[Flock] Load carbon footprint Error',
  props<{ error: Error }>(),
);

export const calculateCarbonFootprintRequest = createAction(
  '[Flock] Calculate carbon footprint request',
  props<{ flockId: number }>(),
);
export const calculateCarbonFootprintStart = createAction(
  '[Flock] Calculate carbon footprint Start',
);

export const calculateCarbonFootprintFailure = createAction(
  '[Flock] Calculate carbon footprint Failure',
  props<{ error: string }>(),
);

export const resetCarbonFootprint = createAction('[Flock] Reset Carbon Footprint');

export const setSustainabilityNoticeVisibility = createAction(
  '[Sustainability] Set sustainability notice visibility',
  props<{ visible: boolean }>(),
);

export const refreshCarbonFootprintRequest = createAction(
  '[Flock] Refresh carbon footprint request',
  props<{ flockId: number }>(),
);
export const refreshCarbonFootprintFailure = createAction(
  '[Flock] Refresh carbon footprint Error',
  props<{ error: Error }>(),
);
